module.exports = __webpack_public_path__ + "img/send_button_white.a977cde2.svg";